import React from 'react';
import {useIntl} from 'react-intl';

const EmptyDocuments = () => {
    const intl = useIntl();
    const text = intl.formatMessage({id: 'DOCUMENTS.ALL.EMPTY'});
    return (
        <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
            <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                <img alt={text} src="/media/icons/duotune/files/fil015.svg" className="w-100px" />
            </div>
            <div className="card-header">
                <div className="card-title">{text}</div>
            </div>
        </div>
    );
};

export default EmptyDocuments;
